import axios from 'axios';
import moment from 'moment';

export const SERVER_IP = process.env.REACT_APP_SERVER_IP;

const client = axios.create({
  baseURL: SERVER_IP,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getSlots = (start, days = 7) => {
  return client.get('/slots/list/', {
    params: {
      start: start,
      days: days,
    },
  });
};

export const createAppointment = ({
  name,
  surname,
  email,
  idType,
  idNumber,
  birthdate,
  gender,
  healthCoverage,
  institution,
  phone,
  address,
  symptoms,
  covid,
  date,
  slot,
  department,
}) => {
  const data = {
    date: date,
    id_type: idType,
    id_number: idNumber,
    email: email,
    first_name: name,
    last_name: surname,
    gender: gender,
    date_of_birthday: moment(birthdate, 'YYYY-MM-DD')
      .format('DD/MM/YYYY')
      .toString(),
    health_coverage: healthCoverage,
    address: address,
    phone: phone,
    symptoms: symptoms,
    covid: covid,
    slot: slot,
    institution: institution,
    departament: department,
  };

  return client.post('/appointments/create/', data);
};

export const getDepartments = () => client.get('/departments/');

export const getSchedules = (date_start, date_end, is_semm_member) =>
  client.get('/appointments/schedules/', {
    params: {
      date_start: date_start,
      date_end: date_end,
      is_semm_member: is_semm_member,
    },
  });

export const getExams = () => client.get('/exam_type/');

export const createExamAppointment = (data) =>
  client.post('/appointments/create_exam_appointment/', data);

export const createPaymentAttempt = (email) =>
  client.post('/payments/attempt/', { email: email });

export const getMpPreference = (body) =>
  client.get('/appointments/payment/', {
    params: {
      price: body.price,
      title: body.title,
      appointment: body.appointment,
    },
  });

export const plexoAuth = (body) =>
  client.post('/integrations/plexo/auth/', body);
